import { FC, memo } from 'react';
import { Tabela } from 'view/component/Tabela/Tabela';
import styled from 'styled-components';
import AvatarPessoa from 'view/component/AvatarPessoa/AvatarPessoa';
import { Paginacao } from 'view/component/Paginacao/Paginacao';
import { BotaoFlat } from 'view/component/Botao/Botao';
import { Servidor } from 'model/ufc/Servidor';
import { useDispatch, useSelector } from 'react-redux';
import { ServidoresSelector } from 'store/Servidores/Servidores.selector';
import { ServidoresAction } from 'store/Servidores/Servidores.action';
import { MensagensErroServidor } from 'view/component/MensagensErroServidor/MensagensErroServidor';
import { Coluna } from 'view/component/Tabela/model/Coluna';
import { ItemTabelaComponentProps } from 'view/component/Tabela/model/ItemTabelaComponentProps';
import { OrdemColunaTabela } from 'view/component/Tabela/model/OrdemColunaTabela';
import { UnidadesUFCSelector } from 'store/UnidadesUFC/UnidadesUFC.selector';
import { UnidadeUFC } from 'model/ufc/UnidadeUFC';


interface BuscaServidoresSectionProps {
  onServidorSelected: (servidor: Servidor) => void;
}


export const ServidoresLista: FC<BuscaServidoresSectionProps> = ({onServidorSelected}) => {
  const dispatch = useDispatch();

  const servidores = useSelector(ServidoresSelector.lista.elementos);
  const isLoading = useSelector(ServidoresSelector.lista.carregando);
  const paginacao = useSelector(ServidoresSelector.lista.paginacao);
  const ordem = useSelector(ServidoresSelector.lista.ordem);

  const erros = useSelector(ServidoresSelector.lista.erros);

  const buscar = (event: any, newPage: number) => dispatch(ServidoresAction.lista.carregarPagina(newPage));
  const alterarOrdem = (ordem: OrdemColunaTabela) => dispatch(ServidoresAction.lista.alterarOrdem(paginacao.atual + 1, ordem));
  
  const headers: Coluna[] = [
    {nome: "Nome",      ordernavel: true, atributoOrdenacao: 'nome', textAlign: 'center'},
    {nome: "Situação",  ordernavel: true, atributoOrdenacao: 'situacaoServidor.descricao', textAlign: 'center'},
    {nome: "Cargo",     ordernavel: true, atributoOrdenacao: 'cargo.deniminacao', textAlign: 'center'},
    {nome: "Exercício", ordernavel: true, atributoOrdenacao: 'unidadeExercicio.nome', textAlign: 'center'},
    {nome: "Ação",      ordernavel: false, textAlign: 'center'},
  ];
  const Item = gerarItem(onServidorSelected);

  return <>
    <MensagensErroServidor erro={erros} />
    <Tabela<Servidor>
      classNameTabela="servidores-lista"
      colunas={headers}
      dados={servidores}
      ItemTabelaComponent={Item}
      colunaConfig={ordem}
      onChangeSort={alterarOrdem}
      loading={isLoading}
      dadosKeyExtractor={item => `${item.idInstitucional}-${item.cargo}`}
      />
    <Paginacao
      paginaAtual={paginacao.atual + 1}
      paginas={paginacao.total}
      onChange={buscar} />
  </>
}


function gerarItem(onItemSelected: (servidor: Servidor) => void): FC<ItemTabelaComponentProps<Servidor>> {
  return memo(({item}) => {
    const unidadeExercicio = useSelector(UnidadesUFCSelector.unidade(item.unidadeExercicio.id));
    const unidadeGrande = useSelector(UnidadesUFCSelector.unidade(getIdUnidadeGrande(unidadeExercicio)));

    const pessoa = {
      idInstitucional: item.idInstitucional,
      nome: item.nome,
    }

    
    const siglaUnidadeExercicio = unidadeExercicio
      ? <> - {unidadeExercicio.sigla}</>
      : <></>
    const siglaUnidadeGrande = unidadeGrande && unidadeGrande.id !== unidadeExercicio?.id
      ? <> - <abbr title={unidadeGrande.nome}>{unidadeGrande.sigla}</abbr></>
      : <></>

    const onSelected = () => onItemSelected(item);
    return (
      <Tr>
        <td><AvatarPessoa pessoa={pessoa} comLink={false} /></td>
        <td><LowerCase>{item.situacao}</LowerCase></td>
        <td><CamelCase>{item.cargo.toLowerCase()}</CamelCase></td>
        <td><CamelCase>{item.unidadeExercicio.nome.toLowerCase()}</CamelCase>{siglaUnidadeExercicio}{siglaUnidadeGrande}</td>
        <td className="center"><BotaoFlat onClick={onSelected}>Selecionar</BotaoFlat></td>
      </Tr>
    )
  });
}


function getIdUnidadeGrande(unidade?: UnidadeUFC) {
  const hierarquia = unidade?.hierarquia;
  const partesHierarquia = hierarquia?.split('.') ?? []
  const idUnidadeGrande = partesHierarquia[3];

  return idUnidadeGrande
    ? parseInt(idUnidadeGrande)
    : 0;
}


const Tr = styled.tr`
  td {
    padding: 0.2cm 0;
  }
`;

const LowerCase = styled.span`
  text-transform: lowercase;
`;
const CamelCase = styled.span`
  text-transform: capitalize;
`;
